import React, { useEffect, useMemo } from "react";
import SelectDropdownV2 from "../../../components/ui/selectdropdown/v2";
import { useAppSelector } from "../../../app/hooks";
import { getCreditAccounts } from "../../creditAccounts/logic/slice";

interface CreditAccountDropdownProps {
  selectedAccountNumber?: string;
  onAccountSelectionChange: (accountNumber: string) => void;
}

const CreditAccountDropdown: React.FC<CreditAccountDropdownProps> = ({
  selectedAccountNumber,
  onAccountSelectionChange,
}) => {
  const accounts = useAppSelector(getCreditAccounts);

  const accountOptions = useMemo(
    () =>
      accounts.map((account) => {
        const accountName = account.account_name?.trim();
        const displayName = accountName || account.ext_account_number;

        return {
          name: displayName,
          value: account.account_number,
          display_component: (
            <div className="flex w-full min-w-0 flex-col items-start justify-center gap-0.5">
              <span
                className="w-full truncate text-sm font-normal leading-5 text-[#0A0A0A]"
                title={displayName}
              >
                {displayName}
              </span>

              <span
                className="w-full truncate text-xs font-normal leading-4 text-[#737373]"
                title={account.ext_account_number}
              >
                {account.ext_account_number}
              </span>
            </div>
          ),
          selected_display_component: (
            <div className="flex min-w-0 items-center gap-2">
              <span className="shrink-0 text-xs font-normal leading-4 text-[#737373]">
                Loan Account
              </span>

              <span
                className="truncate text-sm font-medium leading-5 text-[#000000]"
                title={displayName}
              >
                {displayName}
              </span>
            </div>
          ),
        };
      }),
    [accounts],
  );

  useEffect(() => {
    if (!selectedAccountNumber && accountOptions.length > 0) {
      onAccountSelectionChange(accountOptions[0].value);
    }
  }, [selectedAccountNumber, accountOptions, onAccountSelectionChange]);

  const selectedAccount = accountOptions.find(
    (option) => option.value === selectedAccountNumber,
  );

  return (
    <SelectDropdownV2
      name="Loan Account"
      options={accountOptions}
      selectedOption={selectedAccount}
      onSelectionChange={(option) => onAccountSelectionChange(option.value)}
      enableSearch
      optionClassName="px-2 py-1.5"
      selectedContainerClassName="w-[321px] rounded-lg border border-[#E5E5E5] bg-[#FFFFFF] px-3 py-1.5 shadow-[0_1px_2px_rgba(0,0,0,0.05)]"
    />
  );
};

export default CreditAccountDropdown;